module.exports = __webpack_public_path__ + "img/energy.22a958fb.png";